import { jsx as _jsx } from "react/jsx-runtime";
import {} from 'react';
import { Flex } from '../primitives/index.js';
import {} from '@reservoir0x/relay-design-system/css';
const TokenSelectorContainer = ({ children, css, id }) => {
    return (_jsx(Flex, { align: "center", justify: "between", id: id, css: {
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'start',
            backgroundColor: 'widget-card-background',
            border: 'widget-card-border',
            gap: '3',
            p: '12px 12px',
            borderRadius: 'widget-card-border-radius',
            ...css
        }, children: children }));
};
export default TokenSelectorContainer;
//# sourceMappingURL=TokenSelectorContainer.js.map